var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockFilled(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6V4.125c0-.829.316-1.624.879-2.21A2.94 2.94 0 018 1c.796 0 1.559.33 2.121.915.563.586.879 1.381.879 2.21V6",
    stroke: "#ACB5BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.667c-.828 0-1.5.696-1.5 1.555v6.222C2 14.304 2.672 15 3.5 15h9c.828 0 1.5-.697 1.5-1.556V7.222c0-.859-.672-1.555-1.5-1.555h-9zM8 12a1.667 1.667 0 100-3.333A1.667 1.667 0 008 12z",
    fill: "#ACB5BD"
  })));
}

export default SvgLockFilled;